import React, { useState, useEffect } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const AboutUs = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      style={{
        backgroundColor: '#FFFFFF',
        minHeight: '100vh',
      }}
    >
      {/* Header */}
      <div
        style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        }}
      >
        <Container
          fluid
          style={{
            maxWidth: isMobile ? '100%' : '85%',
            padding: 'clamp(1rem, 3vw, 1.5rem)',
          }}
        >
          <div className='d-flex justify-content-between align-items-center text-white'>
            <Button
              variant='link'
              onClick={() => navigate(-1)}
              className='text-white p-0'
              aria-label='Go back'
            >
              <i className='bi bi-arrow-left fs-4'></i>
            </Button>
            <h5 className='mb-0 fw-bold'>About Us</h5>
            <div style={{ width: '24px' }}></div>
          </div>
        </Container>
      </div>

      {/* Main Content */}
      <Container
        fluid
        style={{
          maxWidth: isMobile ? '100%' : '85%',
          padding: 'clamp(1rem, 3vw, 1.5rem)',
          backgroundColor: '#FFFFFF',
          minHeight: '100vh',
        }}
      >
        <div style={{ lineHeight: '1.8', color: '#333' }}>
          <h5 className='fw-bold mb-3'>
            Building a Simple, Secure, and Transparent Crypto Experience
          </h5>
          <p className='mb-4'>
            Our exchange is built on the belief that cryptocurrency should be
            accessible, transparent, and secure for everyone — not just
            professionals or institutions. We aim to create a trusted
            environment where users can confidently explore, track, and engage
            with digital assets.
          </p>
          <p className='mb-4'>
            The platform is designed to simplify the crypto experience by
            delivering fast, reliable, and easy-to-understand tools. Whether you
            are taking your first step into cryptocurrency or managing your
            activities as an experienced trader, our exchange is built to
            support your journey.
          </p>

          <h5 className='fw-bold mb-3 mt-5'>Our Mission</h5>
          <p className='mb-4'>
            Our mission is to empower users worldwide by providing accurate
            real-time market data, intuitive and efficient tools, and secure
            access to digital asset services. We strive to eliminate unnecessary
            complexity and technical barriers, enabling users to make informed
            decisions with confidence in a rapidly evolving crypto market.
          </p>

          <h5 className='fw-bold mb-3 mt-5'>What We Offer</h5>
          <ul className='mb-4'>
            <li className='mb-2'>
              Live cryptocurrency prices sourced from reliable global markets
            </li>
            <li className='mb-2'>
              A clean, user-friendly interface optimized for both mobile and
              desktop
            </li>
            <li className='mb-2'>
              Strong security architecture focused on data protection and system
              integrity
            </li>
            <li className='mb-2'>
              Transparent operations with clear information and no hidden fees
            </li>
            <li className='mb-2'>
              A globally accessible platform built on modern, scalable
              technology
            </li>
          </ul>

          <h5 className='fw-bold mb-3 mt-5'>Our Technology</h5>
          <p className='mb-4'>
            Our exchange is powered by modern and scalable technologies that
            ensure fast price updates, high availability, and consistent
            performance. We integrate trusted data sources and continuously
            enhance our systems to adapt to market changes and technological
            advancements within the crypto ecosystem.
          </p>

          <h5 className='fw-bold mb-3 mt-5'>Our Values</h5>
          <p className='mb-4'>
            Transparency, security, innovation, and a user-first mindset are the
            foundation of everything we build. Every feature and system
            improvement is guided by our commitment to trust, reliability, and
            long-term value for our users.
          </p>

          <h5 className='fw-bold mb-3 mt-5'>Compliance & Responsibility</h5>
          <p className='mb-4'>
            We are committed to operating responsibly and in alignment with
            applicable laws and regulatory expectations. Cryptocurrency markets
            involve significant risk and volatility. Users are encouraged to
            conduct their own research and assess their risk tolerance before
            engaging with digital assets.
          </p>

          <h5 className='fw-bold mb-3 mt-5'>Join Us</h5>
          <p className='mb-4'>
            Whether you are monitoring market trends, learning about digital
            assets, or exploring new opportunities, our exchange is here to
            support your crypto journey. The future of finance is digital — and
            we are building it together.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default AboutUs;
